import {createFileRoute} from '@tanstack/react-router';

import {layoutTemplateKeys} from '@/features/Library/api/queryKeys';
import {getLayoutTemplate} from '@/features/Library/api/readLayoutTemplate';
import {UpdateLayoutTemplateForm} from '@/features/Library/components/Location/UpdateLayoutTemplateForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/locations/update/$layoutTemplateId'
)({
  component: UpdateLayoutTemplateForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.layoutTemplateId}`);

    return {
      ...context,
      readLayoutTemplateQuery: {
        queryKey: layoutTemplateKeys.detail(params.layoutTemplateId),
        queryFn: () => getLayoutTemplate(params.layoutTemplateId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readLayoutTemplateQuery);
  },
});
